import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLightning = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 21,
	viewBox: "0 0 16 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.9001 2.24254C13.1305 1.70738 12.9586 1.08238 12.486 0.738635C12.0133 0.394885 11.3688 0.426135 10.9274 0.808947L0.9274 9.55895C0.536776 9.9027 0.39615 10.4535 0.579744 10.9379C0.763338 11.4222 1.23209 11.7504 1.75162 11.7504H6.10709L3.10318 18.7582C2.87271 19.2933 3.04459 19.9183 3.51724 20.2621C3.9899 20.6058 4.63443 20.5746 5.07584 20.1918L15.0758 11.4418C15.4665 11.098 15.6071 10.5472 15.4235 10.0629C15.2399 9.57848 14.7751 9.25426 14.2516 9.25426H9.89615L12.9001 2.24254Z",
		fill: "#0FAFAF"
	})
});
export default SvgLightning;
